module.exports = __webpack_public_path__ + "img/popup-game-sucai.fbf3d3b9.png";